import { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router';

import { useCheckInTrigger } from 'src/hooks/useCheckIns';

import { redirectToSsoLogin, isSsoRedirectPending } from 'src/api/utils/sso-redirect';

import { AuthHandoffScreen } from 'src/components/auth-handoff';

import { paths } from './paths';
import { useAuth } from '../hooks/useAuth';

export function ProtectedRoute() {
  const location = useLocation();
  const { isLoading, isAuthenticated } = useAuth();
  const [redirectAlreadyAttempted] = useState(isSsoRedirectPending);
  const isActivityDetail = /^\/activities\/[^/]+\/?$/.test(location.pathname);
  const isAddActivityFlow =
    location.pathname === paths.addActivity.root ||
    location.pathname.startsWith(`${paths.addActivity.root}/`);
  const isCheckIn = location.pathname === paths.checkIn;

  useCheckInTrigger(isAuthenticated && !isActivityDetail && !isAddActivityFlow && !isCheckIn);

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    redirectToSsoLogin(location.pathname + location.search);
  }, [isLoading, isAuthenticated, location.pathname, location.search]);

  if (isAuthenticated) {
    return <Outlet />;
  }

  if (!isLoading && redirectAlreadyAttempted) {
    return <Navigate to={paths.signIn} replace />;
  }

  return <AuthHandoffScreen message={redirectAlreadyAttempted ? 'Signing you in…' : undefined} />;
}
